import React from 'react';
import { Select } from '@economic/taco';
import Field, { FieldProps } from '../Field';

// 'as' must be an instance, anonymous functions are recreated each render
const DropdownField = ({ child: Component, defaultValue, onChange, options, suggestion, ...fieldProps }) => {
    const valueIsSuggested = (fieldProps.value !== undefined || fieldProps.value !== null) && suggestion === fieldProps.value;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement> & { detail: any }): void => {
        onChange(fieldProps.multiselect ? event?.target?.value : event?.detail?.value);
    };

    return <Component {...fieldProps} data={options} highlighted={valueIsSuggested} onChange={handleChange} />;
};

export default function FieldDropdown({ as, fieldClassName, ...props }: FieldProps<any>) {
    const Component = as || Select;
    return <Field {...props} as={DropdownField as any} child={Component} fieldClassName={fieldClassName} />;
}
